import type { AxiosInstance } from 'axios';
import type { paths } from '../schema';
import type { TimelineEntry } from '../types/timeline';
import type { RequestOptionsWithParams } from './types';
import { curry1 } from './utils';

type RoleTimelineEntry = TimelineEntry<
  Record<string, any>,
  | 'role_created'
  | 'role_name_updated'
  | 'role_permission_groups_updated'
  | 'role_deleted'
>;

export type RoleHistoryParams = Required<
  paths['/api/role/{role_id}/history']['get']['parameters']
>['query'];

export type RoleHistory = Omit<
  paths['/api/role/{role_id}/history']['get']['responses']['200']['content']['application/json'],
  'results'
> & {
  results: RoleTimelineEntry[];
};

export const getRoleHistory = async (
  instance: AxiosInstance,
  id: string,
  options?: RequestOptionsWithParams<RoleHistoryParams>
): Promise<RoleHistory> => {
  const res = await instance.get<RoleHistory>(`/role/${id}/history`, options);

  return res.data;
};

export class RoleService {
  public getRoleHistory;

  constructor(private instance: AxiosInstance) {
    this.getRoleHistory = curry1(getRoleHistory)(this.instance);
  }
}
